
export enum IndustryType {
    LocalAuthority = "Local Authority", 
    Healthcare = "Healthcare", 
    Construction = "Construction", 
    Facilities = "Facilities Management", 
    Retail = "Retail", 
    FMCG = "FMCG", 
    Manufacturing = "Manufacturing", 
    Engineering = "Engineering", 
    EmergencyServices = "Emergency Services", 
    Transport = "Transportation", 
    Hospitality = "Hospitality",
    Other = "Other"
}